<template>
    <Forms  ref="frmPermission"
            :title="title"
            :showHelp="true"
            :showClearButtonIcon="true"
            :ShowFooterImbo="true"
            :showSearchIcon="true"
            :showSearchButtonIcon="true"
            v-on:Clear="Clear"
            v-on:Search="Search"
          >
          <div>
               <label class="labelseach">Empreendimento:</label>
                  <select v-model="formSearch.empreendimentoid" name="statusVistoria" class="form-control" id="exampleFormControlSelect2">
                    <option :value="''">Selecione um Empreendimento</option>
                    <option v-for="data in allEmpreendimento" v-bind:key="data.id" :value="data.id">{{data.nome}}</option>
                  </select>
                <label for="txtInsured" class="labelseach mt-3">Cidade:</label>
                    <autocomplete-z ref="CidadeTypeahead"
                          placeholder="Digite uma cidade"
                          iconClass="fas fa-city"
                          :serializer="(cidade) => cidade.nome"
                          :debounceLength="3"
                          :formField="formSearch.cidade"
                          v-on:search="onSearchCidade"
                          v-on:changeCode="onChangeCodeCidade"
                          :ShowCode="false"
                           />
                <label class="labelseach mt-3">Status:</label>
                  <select v-model="formSearch.status"  name="statusVistoria" class="form-control" id="exampleFormControlSelect2">
                    <option :value="''">Todos os Status</option>
                     <option v-for="(data) in dataEnum" v-bind:key="data.enum" :value="data.enum">{{data.descricao == null ? '' : data.descricao }}</option>
                  </select>
            </div>
  </Forms>
</template>

<script>
import Searchenterprise from './searchenterprise'
export default Searchenterprise
</script>

<style scoped>
.labelseach{
  margin-bottom: 3px;
  font-size: 14px;
  font-weight: bold
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/enterprise/components/searchenterprise/searchenterprise.vue